import { magic } from '@gig/magic-sdk';

var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const PROMOTIONS_NAMESPACE = "PROMOTIONS_NAMESPACE";
const SET_CATEGORIES = "SET_CATEGORIES";
const SET_ENTRIES = "SET_ENTRIES";
const SET_CATEGORIES_LANGUAGE = "SET_CATEGORIES_LANGUAGE";
const SET_CATEGORIES_LOGGED_IN = "SET_CATEGORIES_LOGGED_IN";
const SET_ENTRIES_LANGUAGE = "SET_ENTRIES_LANGUAGE";
const SET_ENTRIES_LOGGED_IN = "SET_ENTRIES_LOGGED_IN";
const promotionsGetters = {
  categories(state) {
    return state.categories;
  },
  entries(state) {
    return state.entries;
  }
};
const promotionsActions = {
  fetchCategories(_0, _1) {
    return __async(this, arguments, function* ({
      commit,
      getters,
      state
    }, lang) {
      const userLoggedIn = magic.session.isCreated();
      if (getters.categories.length && state.categoriesLanguage === lang && state.categoriesLoggedIn === userLoggedIn) {
        return;
      }
      commit(SET_CATEGORIES_LANGUAGE, lang);
      commit(SET_CATEGORIES_LOGGED_IN, userLoggedIn);
      const categories = yield magic.methods.promotions.getCategories(lang);
      commit(SET_CATEGORIES, categories);
    });
  },
  fetchEntries(_0, _1) {
    return __async(this, arguments, function* ({
      commit,
      getters,
      state
    }, {
      type,
      lang,
      mobile
    }) {
      const userLoggedIn = magic.session.isCreated();
      if (getters.entries.length && state.entriesLanguage === lang && state.entriesLoggedIn === userLoggedIn) {
        return;
      }
      commit(SET_ENTRIES_LANGUAGE, lang);
      commit(SET_ENTRIES_LOGGED_IN, userLoggedIn);
      const entries = yield magic.methods.promotions.filter(type, lang, mobile);
      commit(SET_ENTRIES, entries);
    });
  },
  refreshEntries(_0, _1) {
    return __async(this, arguments, function* ({ commit }, {
      type,
      lang,
      mobile
    }) {
      const entries = yield magic.methods.promotions.filter(type, lang, mobile);
      commit(SET_ENTRIES, entries);
    });
  }
};
const promotions = {
  namespaced: true,
  state: {
    categories: [],
    categoriesLanguage: null,
    categoriesLoggedIn: false,
    entries: [],
    entriesLanguage: null,
    entriesLoggedIn: false
  },
  getters: promotionsGetters,
  actions: promotionsActions,
  mutations: {
    [SET_CATEGORIES](state, categories) {
      state.categories = categories;
    },
    [SET_ENTRIES](state, entries) {
      state.entries = entries;
    },
    [SET_CATEGORIES_LANGUAGE](state, language) {
      state.categoriesLanguage = language;
    },
    [SET_ENTRIES_LANGUAGE](state, language) {
      state.entriesLanguage = language;
    },
    [SET_CATEGORIES_LOGGED_IN](state, loggedIn) {
      state.categoriesLoggedIn = loggedIn;
    },
    [SET_ENTRIES_LOGGED_IN](state, loggedIn) {
      state.entriesLoggedIn = loggedIn;
    }
  }
};

export { PROMOTIONS_NAMESPACE, promotions, promotionsActions, promotionsGetters };
